export default "__VITE_ASSET__d069a54e__"